export default "__VITE_ASSET__99Yb4lyu__"